module.exports = __webpack_public_path__ + "media/success_sweepstakes/beachball-3e3e59e1.png";